import { Avatar, Box, Button, Text } from '@factorialco/deprecated-design-system'
import { ProjectionKind, useTaskDataTable } from 'generated/resources/datatable.graphql'

import DataTable from 'modules/core/components/DataTable'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import buildUrl from 'modules/core/lib/buildUrl'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

interface Props {
  meetingId: string
}

const TasksDataTable = ({ meetingId }: Props) => {
  const { navigation } = useNavigation()
  const source = useTaskDataTable(
    [
      {
        identifier: 'name',
        title: i18n.t('one_on_ones.meeting.tasks.table.name'),
        fixed: true,
        kind: ProjectionKind.Custom,
        template: '{{ name }}',
        colSpan: 3,
        render: (task) => {
          return <Text.Normal weight="medium">{task.name}</Text.Normal>
        },
      },
      {
        identifier: 'assignedTo',
        title: i18n.t('one_on_ones.meeting.tasks.table.assigned_to'),
        fixed: true,
        kind: ProjectionKind.Custom,
        template: '{{ assignedTo }}',
        render: (task) => {
          return (
            <Box flexDirection="row">
              {task.assignees.map((assignee) => {
                return (
                  <Avatar
                    key={assignee.id}
                    size="s24"
                    url={buildUrl(assignee.access.avatar)}
                    label={assignee.fullName || 'Undefined'}
                  />
                )
              })}
            </Box>
          )
        },
      },
      {
        identifier: 'dueOn',
        title: i18n.t('one_on_ones.meeting.tasks.table.due'),
        fixed: true,
        kind: ProjectionKind.Custom,
        template: '{{ dueOn }}',
        render: (task) => {
          return <Text.Normal>{dateBackendDateTimeToUI(task.dueOn!)}</Text.Normal>
        },
      },
      {
        identifier: 'actions',
        kind: ProjectionKind.Decorative,
        width: 100,
        fixed: true,
        render: (task) => {
          return (
            <Box flexDirection="row" justifyContent="flexEnd">
              <Button.Router
                type="secondary"
                to={navigation.tasks.taskId.fullPath({ taskId: String(task.taskId) })}
                iconName="arrow-right"
              />
            </Box>
          )
        },
      },
    ],
    {
      variables: { meetingIds: [meetingId] },
    }
  )

  return (
    <DataTable.Provider
      source={source}
      pagination={{
        kind: 'offset',
        itemsPerPage: 10,
        infiniteScroll: true,
      }}
      sort={{
        path: 'created_at',
        direction: 'desc',
      }}
    >
      <Box gap="s16">
        <DataTable.HeadBar disableDefaultActions />
        <DataTable.Table emptyState={i18n.t('one_on_ones.meeting.tasks.empty_state')} />
      </Box>
    </DataTable.Provider>
  )
}

export default TasksDataTable
